import jQuery from 'jquery';
import Cookies from 'js-cookie';

// Variables
const
	$headerTop = document.getElementById( 'headerTop' );

/**
 * Scroll to the current hash target.
 */
const anchorsInit = function() {
	let $backToTop = document.querySelectorAll( '.button--back-to-top' );

	window.addEventListener( 'hashchange', windowHashChange );

	if ( $backToTop ) {
		for ( let index = 0; index < $backToTop.length; index++ ) {
			const $element = $backToTop[index];
			$element.addEventListener( 'click', backToTopClick );
		}
	}

	// Kick off on page load.
	windowHashChange();
};

/**
 * Moves to target in hash on window hashchange.
 */
const windowHashChange = function() {
	const hash = window.location.hash.replace( '#', '' );

	// Check hash is empty for early exit.
	if ( '' === hash ) {
		return;
	}

	// Scroll to the target
	anchorScroll( hash );
};

/**
 * Scrolls the screen to the target specified.
 *
 * @param {*String} id The ID of the target. Default false.
 */
const anchorScroll = function( id = false ) {
	const amcnBioClick = Cookies.getJSON( 'amcn-bio-click' );
	let
		$adminBar    = document.getElementById( 'wpadminbar' ),
		headerHeight = jQuery( $headerTop ).height(),
		scrollY      = 0,
		$target      = null,
		hash         = '';

	// Check for a cookie.
	// If there is one, it'll take over auto scroll.
	if ( !! amcnBioClick ) {
		return;
	}

	// Check if a target ID was supplied.
	if ( ! id ) {
		hash = window.location.hash.replace( '#', '' );
	} else {
		hash = id;
	}

	// Update vars
	$target = document.getElementById( hash );

	if ( $target ) {
		scrollY = jQuery( $target ).offset().top - headerHeight;
	}

	if ( $adminBar ) {
		scrollY = scrollY - jQuery( $adminBar ).height();
	}

	// Only scroll if the target exists.
	if ( $target ) {
		jQuery( 'html,body' ).animate({ scrollTop: scrollY }, 400 );
	}
};

/**
 * Scrolls to the link target.
 * Used mainly for back to top action in the accordion component.
 *
 * @param {*Object} event The event object.
 */
const backToTopClick = function( event ) {
	const
		$element = this,
		target   = $element.getAttribute( 'href' ),
		id       = target.replace( '#', '' );

	event.preventDefault();

	anchorScroll( id );
};

export { anchorsInit };
